module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacyAgreementManage-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "agreement-describe"
  }, [_c('span', [_vm._v("更新时间:" + _vm._s(_vm.agreementModifyTimeStr) + "               最新版本号:" + _vm._s(_vm.agreementCurrentVersion))])]), _vm._v(" "), _c('quill-editor', {
    ref: "text",
    staticClass: "editor",
    staticStyle: {
      "height": "400px"
    },
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.agreementContent),
      callback: function($$v) {
        _vm.agreementContent = $$v
      },
      expression: "agreementContent"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "handle-button"
  }, [_c('el-button', {
    on: {
      "click": _vm.handlePublic
    }
  }, [_vm._v("发布")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleTempSave
    }
  }, [_vm._v("暂存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleBack
    }
  }, [_vm._v("恢复")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "是否发布新版本隐私协议"
    },
    on: {
      "close": _vm.cancelPublicDialog
    },
    model: {
      value: (_vm.publicDialogVisible),
      callback: function($$v) {
        _vm.publicDialogVisible = $$v
      },
      expression: "publicDialogVisible"
    }
  }, [_c('el-form', {
    ref: "publicAgreementForm",
    attrs: {
      "model": _vm.publicAgreementForm,
      "rules": _vm.publicAgreementFormRules
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "52px"
    }
  }, [_vm._v("发布新版本隐私协议后，全部用户登录系统时需要再次同意 ")]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "22px",
      "width": "500px"
    },
    attrs: {
      "label": "当前版本号为：",
      "prop": "version",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入版本号",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.publicAgreementForm.version),
      callback: function($$v) {
        _vm.$set(_vm.publicAgreementForm, "version", $$v)
      },
      expression: "publicAgreementForm.version"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.publicAgreementButtonDisabled,
      "type": "primary"
    },
    on: {
      "click": _vm.publicAgreementOnSubmit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "回退确认"
    },
    on: {
      "close": _vm.cancelBackAgreementDialog
    },
    model: {
      value: (_vm.backAgreementDialogVisible),
      callback: function($$v) {
        _vm.backAgreementDialogVisible = $$v
      },
      expression: "backAgreementDialogVisible"
    }
  }, [_c('span', [_vm._v("是否要回退到上次发布版本 ")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelBackAgreementDialog
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.backAgreementButtonDisabled,
      "type": "primary"
    },
    on: {
      "click": _vm.backAgreementOnSubmit
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-title"
  }, [_c('span', {
    staticClass: "centered-text"
  }, [_vm._v("JLL法律声明及隐私权政策")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21048d06"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/system_setup/privacy_agreement_manage.vue
// module id = 878
// module chunks = 1